export const underscoreToTitleCase = (text: string) => {
  return text.toLowerCase().split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export const underscoreToSentence = (text: string) => {
  // only convert the first letter of the first word to uppercase
  return text.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

export const toTitleCase = (text: string) => {
  return text.toLowerCase().split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}
